module.exports = __webpack_public_path__ + "img/logo-cepe-light.7ebf8e89.png";